<main data-testid="app-main">
  <router-outlet />

  @if(syncManager.doesSupportServiceWorker === false && syncManager.showOfflineWarning) {
    <p-message severity="warn"
               data-testid="app-banner-offline-warning"
               (click)="syncManager.hideOfflineWarning()"
               closable>{{offlineWarning}}</p-message>
  }
  <p-toast [position]="toastPosition"
           [breakpoints]="breakpoints"
           data-testid="app-toast"
           (onClose)="toast.onToastClosed()">
    <ng-template pTemplate="message"
                 let-message>
      <i class="toast-message-icon pi"
         [class.pi-check-circle]="message.severity === 'success'"
         [class.pi-info-circle]="message.severity === 'info'"
         [class.pi-exclamation-triangle]="message.severity === 'warn'"
         [class.pi-times-circle]="message.severity === 'error'"
         aria-hidden="true"
         data-testid="toast-message-icon"></i>
      <div class="toast-message-content">
        <div class="toast-message-header">
          <span class="toast-summary">{{ message.summary }}</span>
          @if (message.data?.action) {
            <button class="toast-action-btn"
                    (click)="message.data.action.onClick()"
                    data-testid="toast-action-btn">
              {{ message.data.action.label }}
            </button>
          }
        </div>
        @if (message.detail) {
          <span class="toast-detail p-toast-detail">{{ message.detail }}</span>
        }
      </div>
    </ng-template>
  </p-toast>
  <p-dialog [(visible)]="modal.isDialogVisible"
            [modal]="true"
            [closable]="false"
            [closeOnEscape]="false"
            [style]="{'max-width': '75vw'}"
            class="global-modal"
            data-testid="app-modal-global">
    <ng-template *ngIf="modal.icon !== modalIcon.None"
                 #header>
      @if(modal.icon === modalIcon.Warning) {
        <img src="assets/icons/warning-icon.svg"
             alt="Warning"
             class="warning-icon"
             data-testid="app-modal-icon-warning">
      }
      @else if(modal.icon === modalIcon.Info) {
        <img src="assets/icons/info.svg"
             alt="Info"
             class="info-icon"
             data-testid="app-modal-icon-info">
      }
      @else if(modal.icon === modalIcon.Error) {
        <img src="assets/icons/error.svg"
             alt="Error"
             class="error-icon"
             data-testid="app-modal-icon-error">
      }
      @else if(modal.icon === modalIcon.Success) {
        <img src="assets/icons/check.svg"
             alt="Success"
             class="success-icon"
             data-testid="app-modal-icon-success">
      }
      @else if (modal.icon === modalIcon.ErrorOutline) {
        <img src="assets/icons/error-outline.svg"
             alt="Error"
             class="error-icon"
             data-testid="app-modal-icon-error-outline">
      }
    </ng-template>
    <div class="global-modal-header"
         data-testid="app-modal-text-header">{{modal.dialogHeader}}</div>
    <div *ngIf="modal.dialogSubHeader"
         class="global-modal-subheader"
         data-testid="app-modal-text-subheader">{{modal.dialogSubHeader}}</div>
    <div class="global-modal-message"
         data-testid="app-modal-text-message">{{modal.dialogMessage}}</div>
    <div class="global-modal-footer"
         data-testid="app-modal-footer">
      <p-button *ngIf="modal.onCancel"
                severity="secondary"
                styleClass="bqa-primary-btn p-fullwidth-button"
                data-testid="app-modal-btn-cancel"
                (click)="modal.onCancel(); modal.isDialogVisible = false;">
        {{modal.cancelLabel}}
      </p-button>
      <p-button *ngIf="modal.onAction"
                [severity]="modal.isDestructiveAction ? 'danger' : 'contrast'"
                [styleClass]="modal.isDestructiveAction ? 'bqa-danger-btn p-fullwidth-button' : 'bqa-primary-btn p-fullwidth-button'"
                data-testid="app-modal-btn-action"
                (click)="modal.onAction(); modal.isDialogVisible = false;">
        {{modal.actionLabel}}
      </p-button>
    </div>
  </p-dialog>
  @if (isNonProductionEnvironment) {
    <app-log-viewer-modal [(visible)]="isLogViewerOpen" />
  }
</main>
